import type { Project } from '@finsim/model';

/*
 * Unload-safe save: IndexedDB writes are asynchronous and may not finish while a page unloads, so
 * on page hide the latest unsaved project is also written synchronously to localStorage. On load a
 * pending copy wins over IndexedDB; it is cleared once IndexedDB has the project.
 */
const key = (id: string): string => `finsim:pending:${id}`;

export function writePending(project: Project): void {
  try {
    localStorage.setItem(key(project.id), JSON.stringify(project));
  } catch {
    // Quota or blocked storage: nothing more we can do during unload.
  }
}

export function readPending(id: string): unknown {
  try {
    const raw = localStorage.getItem(key(id));
    return raw === null ? undefined : (JSON.parse(raw) as unknown);
  } catch {
    return undefined;
  }
}

export function clearPending(id: string): void {
  try {
    localStorage.removeItem(key(id));
  } catch {
    // Ignore.
  }
}
